import {BooleanNumber} from "types";

export type GetListRequest = {
    skip?: string | number;
    take?: string | number;
};

export enum JobCheckColumnShort {
    IDNumber,
    JobNumber,
    OtherNumber,
    KOJ,
    Project,
    Status,
    District,
    RequestDate,
    DueDate,
    LastCheckDate,
}

export enum JobHoldColumnShort {
    IDNumber,
    JobNumber,
    OtherNumber,
    KOJ,
    Project,
    Status,
    District,
    RequestDate,
    DueDate,
}

export enum JobCancelColumnShort {
    IDNumber,
    JobNumber,
    OtherNumber,
    KOJ,
    Project,
    Status,
    District,
    RequestDate,
    DueDate,
}

export type GetListWithFilterRequest = {
    id?: string;
    number_id?: string;
    number_job?: string;
    other_number?: string;
    koj?: string;
    project?: string;
    status?: string;
    district?: string;
    startReqDate?: string;
    endReqDate?: string;
    startDueDate?: string;
    endDueDate?: string;
    startCheckDate?: string;
    endCheckDate?: string;
    column?: JobCheckColumnShort;
    sort?: number;
    skip: number;
    take: number;
};

export type JobCheck = {
    id: string;
    number_id: string;
    number_job: string;
    sales_order: string;
    date_due: string;
    fielder: string;
    category_id: string;
    category_name: string;
    type_id: string;
    type_name: string;
    district_id: string;
    district_name: string;
    requestor: string;
    is_priority: boolean;
    is_mre: boolean;
    is_katapult: boolean;
    kind_id: string;
    kind_name: string;
    department_id: string;
    department_name: string;
    source_id: string;
    source_name: string;
    status_id: string;
    status_name: string;
    date_due_fielding: string;
    project_id: string;
    project_name: string;
    waiting_subject_id: string;
    waiting_notes: string;
    waiting_ts: string;
    ts_created: string;
    cancel_notes: string | null;
    prep_notes: string | null;
    prep_reference_job_id: string;
    prep_reference_job_number_job: string;
    employee_prep_list: string | null;
    percent_prep: number;
    percent_cs: number;
    percent_qc: number;
    qc_notes: string | null;
    calcspec_notes: string | null;
    pole_total: number;
    waiting_subject_name: string;
    last_check_user: string;
    last_check_user_name: string;
    department_owner_name: string;
    waiting_by_user: string;
    waiting_by_user_name: string;
    last_check_date: string;
};

export type PendingRequest = {
    id: string;
    userId: string;
}

export type GetHoldRequest = {
    id?: string;
};

export type GetHoldWithFilterRequest = {
    id?: string;
    number_id?: string;
    number_job?: string;
    other_number?: string;
    koj?: string;
    project?: string;
    status?: string;
    district?: string;
    startReqDate?: string;
    endReqDate?: string;
    startDueDate?: string;
    endDueDate?: string;
    column?: JobHoldColumnShort;
    sort?: number;
    skip: number;
    take: number;
};


export type GetCancelRequest = {
    id?: string;
};

export type GetCancelWithFilterRequest = {
    id?: string;
    number_id?: string;
    number_job?: string;
    other_number?: string;
    koj?: string;
    project?: string;
    status?: string;
    district?: string;
    startReqDate?: string;
    endReqDate?: string;
    startDueDate?: string;
    endDueDate?: string;
    column?: JobCancelColumnShort;
    sort?: number;
    skip: number;
    take: number;
};


export type JobHold = {
    id: string;
    number_id: string;
    number_job: string;
    sales_order: string;
    date_due: string;
    fielder: string;
    category_id: string;
    category_name: string;
    type_id: string;
    type_name: string;
    district_id: string;
    district_name: string;
    requestor: string;
    is_priority: boolean;
    is_mre: boolean;
    is_katapult: boolean;
    kind_id: string;
    kind_name: string;
    department_id: string;
    department_name: string;
    source_id: string;
    source_name: string;
    status_id: string;
    status_name: string;
    date_due_fielding: string;
    project_id: string;
    project_name: string;
    waiting_subject_id: string;
    waiting_notes: string;
    waiting_ts: string;
    ts_created: string;
    cancel_notes: string | null;
    prep_notes: string | null;
    prep_reference_job_id: string;
    prep_reference_job_number_job: string;
    employee_prep_list: string | null;
    percent_prep: number;
    percent_cs: number;
    percent_qc: number;
    qc_notes: string | null;
    calcspec_notes: string | null;
    pole_total: number;
    waiting_subject_name: string;
    department_owner_name: string;
    hold_by_user: string;
    hold_by_user_name: string;
    hold_ts: string;
};

export type JobCancel = {
    id: string;
    number_id: string;
    number_job: string;
    sales_order: string;
    date_due: string;
    fielder: string;
    category_id: string;
    category_name: string;
    type_id: string;
    type_name: string;
    district_id: string;
    district_name: string;
    requestor: string;
    is_priority: boolean;
    is_mre: boolean;
    is_katapult: boolean;
    kind_id: string;
    kind_name: string;
    department_id: string;
    department_name: string;
    source_id: string;
    source_name: string;
    status_id: string;
    status_name: string;
    date_due_fielding: string;
    project_id: string;
    project_name: string;
    waiting_subject_id: string;
    waiting_notes: string;
    waiting_ts: string;
    ts_created: string;
    cancel_notes: string | null;
    prep_notes: string | null;
    prep_reference_job_id: string;
    prep_reference_job_number_job: string;
    employee_prep_list: string | null;
    percent_prep: number;
    percent_cs: number;
    percent_qc: number;
    qc_notes: string | null;
    calcspec_notes: string | null;
    pole_total: number;
    waiting_subject_name: string;
    department_owner_name: string;
    cancel_by_user: string;
    cancel_by_user_name: string;
    cancel_ts: string;
};

export type JobHoldList = {
    list: JobHold[];
    total: number;
}